/** Client-side mirrors of the server's request-size caps.
 *  Server truth: service/models.py. Imports ship in 1000-row batches rather
 *  than the 10_000-row request maximum so they can pace around the route's
 *  5/minute rate limit (see import.ts). */

/** Max ids per bulk-mutation request (delete-batch / restore-batch / re-extract /
 *  re-classify / refine-subcategory / batch-update). */
export const BULK_IDS_MAX = 1000;

/** Rows per /api/bookmarks/import request. */
export const IMPORT_BATCH_SIZE = 1000;

/** Bookmark request-field caps mirrored from service/models.py. */
export const BOOKMARK_URL_MAX_LENGTH = 8192;
export const BOOKMARK_DOM_HTML_MAX_LENGTH = 5_000_000;
export const BOOKMARK_BASE64_MAX_LENGTH = 15_000_000;

/** Largest binary payload guaranteed to fit after standard base64 encoding. */
export const BOOKMARK_CAPTURE_BINARY_MAX_BYTES = Math.floor(BOOKMARK_BASE64_MAX_LENGTH / 4) * 3;

/** Split ids into ≤size chunks, preserving order. Empty input → no chunks. */
export function chunkIds(ids: readonly string[], size: number): string[][] {
  const chunks: string[][] = [];
  for (let i = 0; i < ids.length; i += size) {
    chunks.push(ids.slice(i, i + size));
  }
  return chunks;
}
